export const SET_NOTICE = 'SET_NOTICE';
export const CLOSE_NOTICE = 'CLOSE_NOTICE';
export const CLEAR_NOTICE = 'CLEAR_NOTICE';
export const SET_NOTICE_ERROR = 'SET_NOTICE_ERROR';
export const closeAlert = params => ({ type: CLOSE_NOTICE, params });
export const sendAlert = params => ({ type: SET_NOTICE, params });
